import React from 'react';
import {DataTable} from 'primereact/datatable';
import {Column} from "primereact/column";
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import TitlePage from "../../app/Title/TitlePage/TitlePageView";
import {amountDataTableTemplate, percentDataTableTemplate} from "../../utils/formatters/Numbers";
import LinearProgress from "@material-ui/core/LinearProgress";
import {Divider} from "@material-ui/core";


const ContractOTCView = (props) => {

    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <div>
                <Paper elevation={5}
                       style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                    {props.messagesGrowl}
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <TitlePage title="Administración \ Contrato Bilateral OTC"/>
                        </Grid>
                        <Grid item xs={6}>
                            <Button
                                label="Buscar"
                                style={{'float': 'right'}}
                                onClick={props.getDataContracts}
                            />
                        </Grid>
                        <Grid item xs={12}> <Divider/> </Grid>
                        <Grid item xs={12}>
                            <DataTable value={props.dataContractOTC}
                                       responsive={true}
                                       selectionMode="single"
                                       onSelectionChange={props.handleSelectContract}
                                       resizableColumns={true}
                                       columnResizeMode={"fit"}>
                                <Column field="otc" header="OTC"
                                        style={{textAlign: 'center', width: '5%'}}
                                        body={props.formatOTC} sortable={true}/>
                                <Column field="nomCorto" header="Institución"
                                        style={{textAlign: 'left'}} sortable={true}/>
                                <Column field="aforoOtcPorCien" header="Aforo OTC"
                                        style={{textAlign: 'right', width: '8%'}}
                                        body={percentDataTableTemplate} sortable={true}/>
                                <Column field="cuenta" header="Cuenta Garantías"
                                        style={{textAlign: 'left'}} sortable={true}/>
                                <Column field="descrAforo" header="Nivel de Confianza"
                                        style={{textAlign: 'left'}} sortable={true}/>
                                <Column field="lineaCredito" header="Línea de Crédito"
                                        body={amountDataTableTemplate}
                                        style={{textAlign: 'right'}} sortable={true}/>
                                <Column field="lineaUtilizada" header="Línea Utilizada"
                                        body={amountDataTableTemplate}
                                        style={{textAlign: 'right'}} sortable={true}/>
                                <Column field="lineaDisponible" header="Línea Disponible"
                                        body={amountDataTableTemplate}
                                        style={{textAlign: 'right'}} sortable={true}/>
                                <Column header="Acciones"
                                        style={{textAlign: 'center', width: '8%'}}
                                        body={props.contractOTCOrderActionTemplate}/>
                            </DataTable>
                        </Grid>
                    </Grid>
                </Paper>
            </div>
        </React.Fragment>
    )
};

export default /*withStyles(styles)*/(ContractOTCView);
